module.exports = __webpack_public_path__ + "static/img/banner.9a83fb2a.png";